
const types = {
	BUNDLE_DETAILS_GET_REQUEST: 'BUNDLE_DETAILS_GET_REQUEST',
	BUNDLE_DETAILS_GET_RECEIVE: 'BUNDLE_DETAILS_GET_RECEIVE',
	BUNDLE_DETAILS_GET_ERROR: 'BUNDLE_DETAILS_GET_ERROR',

	API_DETAILS_IN_BUNDLE_GET_REQUEST: 'API_DETAILS_IN_BUNDLE_GET_REQUEST',
	API_DETAILS_IN_BUNDLE_GET_RECEIVE: 'API_DETAILS_IN_BUNDLE_GET_RECEIVE',
	API_DETAILS_IN_BUNDLE_GET_ERROR: 'API_DETAILS_IN_BUNDLE_GET_ERROR',

	API_SPEC_IN_BUNDLE_GET_REQUEST: 'API_SPEC_IN_BUNDLE_GET_REQUEST',
	API_SPEC_IN_BUNDLE_GET_RECEIVE: 'API_SPEC_IN_BUNDLE_GET_RECEIVE',
	API_SPEC_IN_BUNDLE_GET_ERROR: 'API_SPEC_IN_BUNDLE_GET_ERROR',
};

const INITIAL_STATE = {
	apiInfo: {
		data: null,
		isFetching: false,
		error: ''
	},
	bundleDetails: {
		data: null,
		isFetching: false,
		error: ''
	},
	apiDetailsInBundle: {
		isFetching: false,
		error: ''
	},
	apiSpecInBundle: {
		isFetching: false,
		error: ''
	},
};

export { types, INITIAL_STATE };
